import type { ReportDataRow, ReportRunResponse } from '../../_types';

const sortByCaseNumber = (a?: string, b?: string) => {
  if (!a && !b) return 0;
  if (!a) return 1;
  if (!b) return -1;
  return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
};

export const transformReportData = (data: ReportRunResponse): ReportDataRow[] => {
  const sortedRecords = [...data.content].sort((a, b) => sortByCaseNumber(a.caseNumber, b.caseNumber));

  return sortedRecords.map((record, index) => {
    const row: ReportDataRow = {
      id: record.caseNumber ? `${record.caseNumber}-${index}` : `no-case-${index}`,
      caseNumber: record.caseNumber,
    };

    record.templates.forEach((template) => {
      template.fields.forEach((field) => {
        row[`t${template.id}_f${field.id}`] = field.value;
      });
    });

    return row;
  });
};
